export const LOGIN = "LOGIN";
export const RESET_LOGIN = "RESET_LOGIN";
//clientes
export const GET_ALL_CLIENTES = "GET_ALL_CLIENTES";
export const GET_CLIENTE = "GET_CLIENTE";
export const RESET_CLIENTE = "RESET_CLIENTE";
export const BUSCA_CLIENTE_POR_NOMBRE_APELLIDO = "BUSCA_CLIENTE_POR_NOMBRE_APELLIDO";
export const BUSCA_CLIENTE_POR_CUIT = "BUSCA_CLIENTE_POR_CUIT";
export const CREA_CLIENTE = "CREA_CLIENTE";
export const MODIFICA_CLIENTE = "MODIFICA_CLIENTE";
export const ELIMINA_CLIENTE = "ELIMINA_CLIENTE";
//productos
export const GET_ALL_PRODUCTOS = "GET_ALL_PRODUCTOS";
export const GET_PRODUCTO_BY_ID = "GET_PRODUCTO_BY_ID";
export const BUSCA_PRODUCTO_POR_NOMBRE = "BUSCA_PRODUCTO_POR_NOMBRE";
export const CREA_PRODUCTO = "CREA_PRODUCTO";
export const MODIF_PRODUCTO = "MODIF_PRODUCTO";
export const ELIMINA_PRODUCTO = "ELIMINA_PRODUCTO";
//proveedores
export const GET_ALL_PROVEEDORES = "GET_ALL_PROVEEDORES";
export const CREA_PROVEEDOR = "CREA_PROVEEDOR";
export const BUSCA_PROVEEDOR_POR_NOMBRE_APELLIDO = "BUSCA_PROVEEDOR_POR_NOMBRE_APELLIDO";
export const BUSCA_PROVEEDOR_POR_CUIT = "BUSCA_PROVEEDOR_POR_CUIT";
export const MODIFICA_PROVEEDOR = "MODIFICA_PROVEEDOR";
export const ELIMINA_PROVEEDOR = "ELIMINA_PROVEEDOR";
export const RESET_PROV = "RESET_PROV";
//remitos ventas
export const GET_ALL_REMITOS = "GET_ALL_REMITOS";
export const ULTIMO_REMITO = "ULTIMO_REMITO";
export const CREA_REMITO = "CREA_REMITO";
export const GET_REMITOS_CLIENTE = "GET_REMITOS_CLIENTE";
export const GET_REMITO_BY_ID = "GET_REMITO_BY_ID";
export const FILTRA_ESTADO = "FILTRA_ESTADO";
export const FILTRA_FECHA = "FILTRA_FECHA";
export const ORDENA_FECHA = "ORDENA_FECHA";
export const FILTRA_FECHAS_REMITOS = "FILTRA_FECHAS_REMITOS";
export const CALC_SALDO_ANTERIOR = "CALC_SALDO_ANTERIOR";
//remitos
export const ORDENA_FECHA_REMITO = "ORDENA_FECHA_REMITO";
//entregas
export const EDITA_ENTREGA = "EDITA_ENTREGA";
export const ELIMINA_ENTREGA = "ELIMINA_ENTREGA";
//remitos compras
export const GET_ALL_REMITOS_COMPRA = "GET_ALL_REMITOS_COMPRA";
export const ULTIMO_REMITO_COMPRA = "ULTIMO_REMITO_COMPRA";
export const RESET_ULTIMO_REMITO_COMPRA = "RESET_ULTIMO_REMITO_COMPRA";
export const CREA_REMITO_COMPRA = "CREA_REMITO_COMPRA";
export const GET_REMITOS_PROVEEDOR = "GET_REMITOS_PROVEEDOR";
export const GET_REMITO_COMPRA_BY_ID = "GET_REMITO_COMPRA_BY_ID";
export const MODIFICA_ANTICIPO_COMPRA = "MODIFICA_ANTICIPO_COMPRA";
export const FILTRA_FECHA_REMITO_COMPRA = "FILTRA_FECHA_REMITO_COMPRA";
export const ORDENA_FECHA_REMITO_COMPRA = "ORDENA_FECHA_REMITO_COMPRA";
export const FILTRA_FECHAS_REMITOS_PROVEEDOR = "FILTRA_FECHAS_REMITOS_PROVEEDOR";
export const RESET_REMITO = "RESET_REMITO";
//gastos y reportes
export const GET_GASTOS_MES = "GET_GASTOS_MES";
export const GET_GASTOS_BY_ID = "GET_GASTOS_BY_ID";
export const GET_REPORTE_MES = "GET_REPORTE_MES";
export const GET_REPORTES_MES_AÑO = "GET_REPORTES_MES_AÑO";
